import { render, staticRenderFns } from "./SchoolClass.vue?vue&type=template&id=cf545a4e&scoped=true"
import script from "./SchoolClass.vue?vue&type=script&lang=js"
export * from "./SchoolClass.vue?vue&type=script&lang=js"
import style0 from "./SchoolClass.vue?vue&type=style&index=0&id=cf545a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf545a4e",
  null
  
)

export default component.exports